import React from "react";
import { isAuthenticated } from "../../auth";
import DeleteHome from "./DeleteHome";
import { Link } from "react-router-dom";

const EditDeletebtn = ({ roomID }) => {
  return (
    <div>
      {isAuthenticated() && isAuthenticated().user.role === 1 ? (
        <div className="ml-3 mb-2 ">
          <div className="d-inline-block">
            <Link
              to={`/listrooms/room/edit/${roomID}`}
              className="btn btn-success "
              style={{ borderRadius: "0" }}
            >
              Edit
            </Link>
          </div>
          <div className="d-inline-block">
            <DeleteHome homeId={roomID} />
          </div>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default EditDeletebtn;
